/*
	Простой pub/sub эмиттер для внутреннего распространения событий WebSocket
	Используется для подписки в handlers и других частях приложения
*/

type Handler = (payload: any) => void;

const createEmitter = () => {
	// Хранилище подписок: event -> набор обработчиков
	const events = new Map<string, Set<Handler>>();

	// Подписка на событие
	const on = (event: string, handler: Handler) => {
		if (!events.has(event)) {
			events.set(event, new Set());
		}

		events.get(event)!.add(handler);
	};

	// Отписка от события
	const off = (event: string, handler?: Handler) => {
		if (!events.has(event)) return;

		// если handler не передан — удаляем все подписки на событие
		if (!handler) {
			events.delete(event);
			return;
		}

		// удаляем конкретный handler
		events.get(event)!.delete(handler);
	};

	// Вызов всех подписчиков события
	const emit = (event: string, payload: any) => {
		const handlers = events.get(event);
		if (!handlers) return;

		handlers.forEach((handler) => {
			try {
				handler(payload);
			} catch (e) {
				// ошибки внутри handler не ломают систему
				console.error(`Error in handler for event ${event}:`, e);
			}
		});
	};

	return {
		on,
		off,
		emit,
	};
};

// singleton экземпляр эмиттера
const emitter = createEmitter();
export default emitter;
